import { ParamIds, Places } from '../../../Constants'
import { MainKeys } from '../../../main/Main.keys'

export class ConfigurationKeys extends MainKeys {
    get place() {
        return Places.configurations
    }

    get selectedConfigTab() {
        return this._intent.getParameterAsString(ParamIds.configListingTabs)
    }

    set selectedConfigTab(value: string | undefined) {
        if (value && value !== 'none') {
            this._intent.setParameter(ParamIds.configListingTabs, value)
        } else {
            this._intent.setParameter(ParamIds.configListingTabs, undefined)
        }
    }
}

export default ConfigurationKeys
